import * as React from 'react';
import { useSelector } from 'react-redux';

import { HousesByTurn } from '../../components/HousesByTurn';
import { SeoWrapper } from '../../components/SeoWrapper';
import { getHousesByTurn } from '../../selectors/newbuilding';

export function HousesByTurnSeoContainer() {
  const housesByTurn = useSelector(getHousesByTurn);

  if (housesByTurn.length === 0) {
    return null;
  }

  return (
    <SeoWrapper>
      <HousesByTurn housesByTurn={housesByTurn} />
    </SeoWrapper>
  );
}
